import { loadStripe, type Stripe } from '@stripe/stripe-js';

/**
 * Lazily load Stripe.js with the publishable key. Returns null when the key
 * isn't configured (so the UI can show a friendly "not set up" message instead
 * of crashing). Set VITE_STRIPE_PUBLIC_KEY in frontend/.env.
 */
const key = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
const configured = !!key && !key.startsWith('pk_test_xxx');

let promise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> | null {
  if (!configured) return null;
  if (!promise) promise = loadStripe(key);
  return promise;
}

export const stripeConfigured = configured;
